$ = require 'jquery'
EditableView = require 'views/internal/editable-view'
Format = require 'lib/markdown/format'
Util = require 'lib/util'
templates = require 'views/internal/templates'

module.exports = class BoardDescView extends EditableView

  initialize: ->
    @makeDebouncedMethods 'render'
    @listenTo @model, 'change:name change:desc', @renderDebounced
    return

  events:
    'click .js-edit-desc': 'editDesc'

  render: ->
    desc = @model.get('desc')
    descData = @model.get('descData')
    data = { hasDesc: !!desc }

    @$el.html(templates.fillFromModel('board_desc', @model, data))

    if data.hasDesc
      $(@el)
      .find('.board-description>div.current')
      .html(Format.markdownAsHtml(desc, { textData: descData }))

    @


  editDesc: (e) ->
    Util.stop(e)
    @edit('desc')
    return



// WEBPACK FOOTER //
// ./app/scripts/views/board/board-desc-view.coffee